import { ConsumptionLineExportStatus } from "../Enums";
import IForeignItem from "../responses/IForeignItem";
import Item from "./Item";
import SignatureItem from "./SignatureItem";

export default class ConsumptionLine extends SignatureItem {
  constructor(
    public item: Item,
    public unitCode: string,
    public quantity: number,
    public exportStatus: ConsumptionLineExportStatus,
    public exportReference: string | undefined,
    public exportResult: string | undefined,
    lot: string | undefined = undefined,
    public bestBefore: string | undefined = undefined,
    public expiry: string | undefined = undefined,
    public isInbound: boolean = false,
    public trackStock: boolean = true,
    public foreignItem: IForeignItem | undefined = undefined,
  ) {
    super(item, unitCode, quantity, lot, bestBefore, expiry, isInbound, trackStock, foreignItem);
  }
}
